<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="parentComponent.filterData()">

            <b-form-group :label="$t('status')" label-cols-sm="3">
                <b-form-checkbox-group v-model="parentComponent.filters.statuses" :options="statusesOption" class="h-100 d-flex align-items-center" :disabled="loading" />
            </b-form-group>

            <div class="d-flex gap-3">
                <ButtonIcon :disabled="parentComponent.loading" @click="parentComponent.filterData()">
                    {{ $t('filter') }}
                </ButtonIcon>
                <ButtonIcon variant="light" :disabled="parentComponent.loading" @click="parentComponent.resetData()">
                    {{ $t('reset') }}
                </ButtonIcon>
            </div>

        </form>
    </Card>
</template>



<script>
    import { ISSUE_STATUS } from '@/services/catalogService';

    export default {
        name: 'Filters',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
            statusesOption() {
                return Object.values(ISSUE_STATUS).map(status => ({ text: this.$tx(`catalogIssueStatuses.${status}`, status), value: status }));
            },
        },
    };
</script>
